import { Container } from "@chakra-ui/react";
import styled from "@emotion/styled";
const Content = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export function FileViwer(props) {
  return (
    <Container
      maxW={["xs", "lg", "3xl"]}
      position="relative"
      paddingBottom=" 56.25%"
      overflowWrap="break-word"
      textAlign="center"
      justifyContent="center"
    >
      <Content
        src={
          "https://docs.google.com/viewer?url=" +
          props.filePath +
          "&embedded=true"
        }
        frameBorder="0"
        title={props.filePath}
        // loading="eager"
        // allowfullscreen
      />
    </Container>
  );
}
